import { noiseFunctions } from './noise';
import { simplex3D } from './simplex3d';

export const fragmentShader = /* glsl */ `

varying vec3 vDirection;

uniform float uTime;
uniform float uSpeed;

${simplex3D}

${noiseFunctions}


//---------------------------------------------
// Color palette
//---------------------------------------------

vec3 coalDark = vec3(
    0.015,
    0.012,
    0.01
);

vec3 coalMid = vec3(
    0.08,
    0.045,
    0.02
);

vec3 ember = vec3(
    1.0,
    0.28,
    0.035
);

vec3 hot = vec3(
    1.0,
    0.65,
    0.12
);


//---------------------------------------------
// Main
//---------------------------------------------

void main()
{
    vec3 dir = normalize(vDirection);


    //-----------------------------------------
    // Slowly rising convection
    //-----------------------------------------

    vec3 flow =
        dir * 2.5;

    flow.y -= uTime * uSpeed * 0.15;


    //-----------------------------------------
    // Warp the atmosphere
    //-----------------------------------------

    vec3 warped =
        warp(flow);


    //-----------------------------------------
    // Main molten structure
    //-----------------------------------------

    float molten =
        fbm(warped * 1.8);


    molten =
        smoothstep(
            -0.25,
            0.65,
            molten
        );


    //-----------------------------------------
    // Cracked hot areas
    //-----------------------------------------

    float cracks =
        turbulence(
            warped * 3.5
        );


    cracks =
        smoothstep(
            0.45,
            0.8,
            cracks
        );


    //-----------------------------------------
    // Rising ember pockets
    //-----------------------------------------

    vec3 emberFlow =
        dir * 7.0;

    emberFlow.y -=
        uTime * 0.45;


    float sparks =
        snoise(
            emberFlow
        );


    sparks =
        smoothstep(
            0.55,
            0.8,
            sparks
        );


    //-----------------------------------------
    // Combine colors
    //-----------------------------------------

    vec3 color =
        mix(
            coalDark,
            coalMid,
            molten
        );


    color =
        mix(
            color,
            ember,
            cracks * 0.65
        );


    color +=
        hot *
        sparks *
        0.8;


    //-----------------------------------------
    // Horizon glow
    //-----------------------------------------

    float horizon =
        pow(
            1.0 - abs(dir.y),
            3.0
        );


    color +=
        ember *
        horizon *
        0.08;


    //-----------------------------------------
    // Tone shaping
    //-----------------------------------------

    color =
        pow(
            color,
            vec3(0.85)
        );


    gl_FragColor =
        vec4(
            color,
            1.0
        );
}

`;
